import React from 'react';
import { toast as toastify } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Mantén los estilos predeterminados

export const toast = ({ title, description }) => {
  toastify(`${title}: ${description}`, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: 'bg-gris-pizarra text-blanco-nieve rounded-lg p-4 font-sans text-sm shadow-lg max-w-[400px]', // Estilos personalizados
    bodyClassName: 'font-medium leading-relaxed', // Estilo para el cuerpo del toast
    closeButtonClassName: 'text-blanco-nieve text-lg', // Estilo para el botón de cierre
    progressClassName: 'bg-azul-lago', // Estilo para la barra de progreso
  });
};
